import { render, staticRenderFns } from "./EloadAddRewards2.vue?vue&type=template&id=598f7582"
import script from "./EloadAddRewards2.vue?vue&type=script&lang=js"
export * from "./EloadAddRewards2.vue?vue&type=script&lang=js"
import style0 from "./EloadAddRewards2.vue?vue&type=style&index=0&id=598f7582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports